import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
    ChevronDown,
    Newspaper,
    Calculator,
    Timer,
    MessageCircleQuestion,
    Cat,
    Users,
    Ticket,
    BookOpen,
} from "lucide-react";

import mainLogo from "../../assets/images/main-logo.png";
import BobaSponsorIcon from "../BobaSponsorIcon/BobaSponsorIcon";
import { trackButtonClick } from "../../services/googleSheetsService";

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMobileSubMenuOpen, setIsMobileSubMenuOpen] = useState(false);
    const [hoveredLink, setHoveredLink] = useState(null);
    const [subMenuPos, setSubMenuPos] = useState({ top: 0, left: 0 });

    const location = useLocation();
    const currentPath = location.pathname;

    const isNavLinkActive = (path) => {
        return currentPath === path;
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
        setHoveredLink(null);
    };

    const handleNavClick = (device, name, path) => {
        trackButtonClick(`導覽列-${device}-${name}`, path);
    };

    const toggleMobileSubMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsMobileSubMenuOpen(!isMobileSubMenuOpen);
        handleNavClick("手機", "賽事配速計算機(展開)", "#");
    };

    const handleMouseEnter = (linkName, e) => {
        setHoveredLink(linkName);
        if (e && e.currentTarget) {
            const rect = e.currentTarget.getBoundingClientRect();
            setSubMenuPos({
                top: rect.top,
                left: rect.right,
            });
        }
    };

    const activeUrls = [
        "/WanjinshiMarathon",
        "/NagoyaMarathon",
        "/Scbmarathon",
        "/TaipeiMarathon",
        "/Tokyo2025",
        "/Osaka2025",
    ];

    return (
        <>
            <div className="main-logo-wrap">
                <Link
                    className="logo-link"
                    to="/"
                    onClick={() => handleNavClick("桌機", "Logo回首頁按鈕", "/")}
                >
                    <div className="main-logo">
                        <img src={mainLogo} alt="喵喵問個痛形象LOGO" />
                    </div>
                    <div className="logo-text">
                        <p>
                            喵喵問個痛
                            <br />
                            <span>CATVV.TW</span>
                        </p>
                    </div>
                </Link>
                <nav className="pc-menu mobile-colse">
                    <ul>
                        <li className={isNavLinkActive("/") ? "active" : ""}>
                            <Link to="/" onClick={() => handleNavClick("桌機", "最新消息", "/")}>
                                <Newspaper size={20} />
                                最新消息
                            </Link>
                        </li>
                        <li className={isNavLinkActive("/Basic") ? "active" : ""}>
                            <Link
                                to="/Basic"
                                onClick={() => handleNavClick("桌機", "通用配速計算機", "/Basic")}
                            >
                                <Calculator size={20} />
                                通用配速計算機
                            </Link>
                        </li>
                        <li
                            className=""
                            onMouseEnter={(e) => handleMouseEnter("marethonTimer", e)}
                            onClick={(e) => handleMouseEnter("marathonTimer", e)}
                            onMouseLeave={() => setHoveredLink(null)}
                        >
                            <a
                                className={
                                    activeUrls.some((url) => isNavLinkActive(url))
                                        ? "main-active"
                                        : ""
                                }
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavClick("桌機", "賽事配速計算機", "#");
                                }}
                                style={{ cursor: "default" }}
                            >
                                <Timer size={20} />
                                賽事配速計算機
                            </a>
                            {hoveredLink === "marethonTimer" && (
                                <div
                                    className="sub-nav"
                                    style={{
                                        position: "fixed",
                                        top: `${subMenuPos.top - 130}px`,
                                        left: `${subMenuPos.left + -10}px`,
                                        right: "auto",
                                    }}
                                >
                                    <li
                                        className={
                                            isNavLinkActive("/Scbmarathon") ? "sub-active" : ""
                                        }
                                    >
                                        <Link
                                            to="/Scbmarathon"
                                            onClick={() =>
                                                handleNavClick(
                                                    "桌機",
                                                    "2026渣打馬拉松",
                                                    "/Scbmarathon"
                                                )
                                            }
                                        >
                                            2026渣打馬拉松
                                        </Link>
                                    </li>
                                    <li
                                        className={
                                            isNavLinkActive("/TaipeiMarathon") ? "sub-active" : ""
                                        }
                                    >
                                        <Link
                                            to="/TaipeiMarathon"
                                            onClick={() =>
                                                handleNavClick(
                                                    "桌機",
                                                    "2025台北馬拉松",
                                                    "/TaipeiMarathon"
                                                )
                                            }
                                        >
                                            2025台北馬拉松
                                        </Link>
                                    </li>
                                    <li
                                        className={
                                            isNavLinkActive("/Tokyo2025") ? "sub-active" : ""
                                        }
                                    >
                                        <Link
                                            to="/Tokyo2025"
                                            onClick={() =>
                                                handleNavClick(
                                                    "桌機",
                                                    "2026東京馬拉松",
                                                    "/Tokyo2025"
                                                )
                                            }
                                        >
                                            2026東京馬拉松
                                        </Link>
                                    </li>
                                    <li
                                        className={
                                            isNavLinkActive("/Osaka2025") ? "sub-active" : ""
                                        }
                                    >
                                        <Link
                                            to="/Osaka2025"
                                            onClick={() =>
                                                handleNavClick(
                                                    "桌機",
                                                    "2026大阪馬拉松",
                                                    "/Osaka2025"
                                                )
                                            }
                                        >
                                            2026大阪馬拉松
                                        </Link>
                                    </li>

                                    <li
                                        className={
                                            isNavLinkActive("/WanjinshiMarathon")
                                                ? "sub-active"
                                                : ""
                                        }
                                    >
                                        <Link
                                            to="/WanjinshiMarathon"
                                            onClick={() =>
                                                handleNavClick(
                                                    "桌機",
                                                    "2026萬金石馬拉松",
                                                    "/WanjinshiMarathon"
                                                )
                                            }
                                        >
                                            2026萬金石馬拉松
                                        </Link>
                                    </li>
                                    <li
                                        className={
                                            isNavLinkActive("/NagoyaMarathon") ? "sub-active" : ""
                                        }
                                    >
                                        <Link
                                            to="/NagoyaMarathon"
                                            onClick={() =>
                                                handleNavClick(
                                                    "桌機",
                                                    "2026名古屋馬拉松",
                                                    "/NagoyaMarathon"
                                                )
                                            }
                                        >
                                            2026名古屋馬拉松
                                        </Link>
                                    </li>
                                </div>
                            )}
                        </li>

                        {/*  */}

                        {/*  */}
                        <li className={isNavLinkActive("/AboutMarathonTimer") ? "active" : ""}>
                            <Link
                                to="/AboutMarathonTimer"
                                onClick={() =>
                                    handleNavClick("桌機", "說說配速計算機", "/AboutMarathonTimer")
                                }
                            >
                                <MessageCircleQuestion size={20} />
                                說說配速計算機
                            </Link>
                        </li>
                        <li className={isNavLinkActive("/AboutMaoMao") ? "active" : ""}>
                            <Link
                                to="/AboutMaoMao"
                                onClick={() =>
                                    handleNavClick("桌機", "關於喵喵問個痛", "/AboutMaoMao")
                                }
                            >
                                <Cat size={20} />
                                關於喵喵問個痛
                            </Link>
                        </li>
                        <li className={isNavLinkActive("/GroupRegistration") ? "active" : ""}>
                            <Link
                                to="/GroupRegistration"
                                onClick={() =>
                                    handleNavClick("桌機", "喵喵團報團購優惠", "/GroupRegistration")
                                }
                            >
                                <Users size={20} />
                                喵喵團報團購優惠
                            </Link>
                        </li>

                        <li
                            onMouseEnter={(e) => handleMouseEnter("ExpoCupon", e)}
                            onMouseLeave={() => setHoveredLink(null)}
                        >
                            <Link
                                className="dev-link"
                                to="#"
                                style={{ cursor: "default" }}
                                onClick={() => handleNavClick("桌機", "博覽會特推優惠", "#")}
                            >
                                <Ticket size={20} />
                                {hoveredLink === "ExpoCupon" ? "開發中" : "博覽會特推優惠"}
                            </Link>
                            {hoveredLink === "ExpoCupon" && (
                                <span
                                    style={{
                                        position: "fixed",
                                        top: `${subMenuPos.top - 20}px`,
                                        left: `${subMenuPos.left + -10}px`,
                                        right: "auto",
                                    }}
                                >
                                    敬請餵食
                                </span>
                            )}
                        </li>
                        <li
                            onMouseEnter={(e) => handleMouseEnter("info", e)}
                            onMouseLeave={() => setHoveredLink(null)}
                        >
                            <Link
                                className="dev-link"
                                to="#"
                                style={{ cursor: "default" }}
                                onClick={() => handleNavClick("桌機", "備賽資訊參考", "#")}
                            >
                                <BookOpen size={20} />
                                {hoveredLink === "info" ? "開發中" : "備賽資訊參考"}
                            </Link>
                            {hoveredLink === "info" && (
                                <span
                                    style={{
                                        position: "fixed",
                                        top: `${subMenuPos.top - 20}px`,
                                        left: `${subMenuPos.left + -10}px`,
                                        right: "auto",
                                    }}
                                >
                                    敬請餵食
                                </span>
                            )}
                        </li>
                    </ul>
                    <BobaSponsorIcon
                        onClick={() =>
                            handleNavClick("桌機", "請我喝珍奶", "https://catvv.bobaboba.me")
                        }
                    />
                </nav>
            </div>

            <div
                className={`main-navigation menu-button ${isMenuOpen ? "open" : ""}`}
                onClick={toggleMenu}
            >
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>

            <nav className={`nav-menu ${isMenuOpen ? "open" : ""}`} onClick={closeMenu}>
                <ul>
                    <li className={isNavLinkActive("/") ? "active" : ""}>
                        <Link to="/" onClick={() => handleNavClick("手機", "最新消息", "/")}>
                            <Newspaper size={20} />
                            最新消息
                        </Link>
                    </li>
                    <li className={isNavLinkActive("/Basic") ? "active" : ""}>
                        <Link
                            to="/Basic"
                            onClick={() => handleNavClick("手機", "通用配速計算機", "/Basic")}
                        >
                            <Calculator size={20} />
                            通用配速計算機
                        </Link>
                    </li>
                    <li>
                        <a
                            href="#"
                            onClick={toggleMobileSubMenu}
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Timer size={20} style={{ marginRight: "10px" }} />
                                賽事配速計算機
                            </div>
                            <ChevronDown
                                size={16}
                                style={{
                                    transform: isMobileSubMenuOpen
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                    transition: "transform 0.3s",
                                }}
                            />
                        </a>
                        {isMobileSubMenuOpen && (
                            <ul
                                className="mobile-sub-menu"
                                style={{ backgroundColor: "rgba(0,0,0,0.2)" }}
                            >
                                <li className={isNavLinkActive("/Scbmarathon") ? "active" : ""}>
                                    <Link
                                        to="/Scbmarathon"
                                        onClick={() =>
                                            handleNavClick("手機", "2026渣打馬拉松", "/Scbmarathon")
                                        }
                                    >
                                        2026渣打馬拉松
                                    </Link>
                                </li>
                                <li className={isNavLinkActive("/TaipeiMarathon") ? "active" : ""}>
                                    <Link
                                        to="/TaipeiMarathon"
                                        onClick={() =>
                                            handleNavClick(
                                                "手機",
                                                "2025台北馬拉松",
                                                "/TaipeiMarathon"
                                            )
                                        }
                                    >
                                        2025台北馬拉松
                                    </Link>
                                </li>
                                <li className={isNavLinkActive("/Tokyo2025") ? "active" : ""}>
                                    <Link
                                        to="/Tokyo2025"
                                        onClick={() =>
                                            handleNavClick("手機", "2026東京馬拉松", "/Tokyo2025")
                                        }
                                    >
                                        2026東京馬拉松
                                    </Link>
                                </li>
                                <li className={isNavLinkActive("/Osaka2025") ? "active" : ""}>
                                    <Link
                                        to="/Osaka2025"
                                        onClick={() =>
                                            handleNavClick("手機", "2026大阪馬拉松", "/Osaka2025")
                                        }
                                    >
                                        2026大阪馬拉松
                                    </Link>
                                </li>
                                <li
                                    className={
                                        isNavLinkActive("/WanjinshiMarathon") ? "active" : ""
                                    }
                                >
                                    <Link
                                        to="/WanjinshiMarathon"
                                        onClick={() =>
                                            handleNavClick(
                                                "手機",
                                                "2026萬金石馬拉松",
                                                "/WanjinshiMarathon"
                                            )
                                        }
                                    >
                                        2026萬金石馬拉松
                                    </Link>
                                </li>
                                <li className={isNavLinkActive("/NagoyaMarathon") ? "active" : ""}>
                                    <Link
                                        to="/NagoyaMarathon"
                                        onClick={() =>
                                            handleNavClick(
                                                "手機",
                                                "2026名古屋馬拉松",
                                                "/NagoyaMarathon"
                                            )
                                        }
                                    >
                                        2026名古屋馬拉松
                                    </Link>
                                </li>
                            </ul>
                        )}
                    </li>
                    <li className={isNavLinkActive("/AboutMarathonTimer") ? "active" : ""}>
                        <Link
                            to="/AboutMarathonTimer"
                            onClick={() =>
                                handleNavClick("手機", "說說配速計算機", "/AboutMarathonTimer")
                            }
                        >
                            <MessageCircleQuestion size={20} />
                            說說配速計算機
                        </Link>
                    </li>

                    <li className={isNavLinkActive("/AboutMaoMao") ? "active" : ""}>
                        <Link
                            to="/AboutMaoMao"
                            onClick={() => handleNavClick("手機", "關於喵喵問個痛", "/AboutMaoMao")}
                        >
                            <Cat size={20} />
                            關於喵喵問個痛
                        </Link>
                    </li>
                    <li className={isNavLinkActive("/GroupRegistration") ? "active" : ""}>
                        <Link
                            to="/GroupRegistration"
                            onClick={() =>
                                handleNavClick("手機", "喵喵團報團購優惠", "/GroupRegistration")
                            }
                        >
                            <Users size={20} />
                            喵喵團報團購優惠
                        </Link>
                    </li>

                    <li
                        onMouseEnter={() => setHoveredLink("ExpoCupon")}
                        onMouseLeave={() => setHoveredLink(null)}
                    >
                        <Link
                            className="dev-link"
                            to="#"
                            style={{ cursor: "default" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleNavClick("手機", "博覽會特推優惠", "#");
                            }}
                        >
                            <Ticket size={20} />
                            {hoveredLink === "ExpoCupon" ? "開發中" : "博覽會特推優惠"}
                        </Link>
                    </li>
                    <li
                        onMouseEnter={() => setHoveredLink("info")}
                        onMouseLeave={() => setHoveredLink(null)}
                    >
                        <Link
                            className="dev-link"
                            to="#"
                            style={{ cursor: "default" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleNavClick("手機", "備賽資訊參考", "#");
                            }}
                        >
                            <BookOpen size={20} />
                            {hoveredLink === "info" ? "開發中" : "備賽資訊參考"}
                        </Link>
                    </li>
                </ul>
                <BobaSponsorIcon
                    onClick={() =>
                        handleNavClick("手機", "請我喝珍奶", "https://catvv.bobaboba.me")
                    }
                />
            </nav>
        </>
    );
}

export default Header;
